import { ScientificAnalysis } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'

export interface ScientificAnalysisDetailModalState {
    scientificAnalysis:ScientificAnalysis | null
}
export const initialScientificAnalysisDetailModalState =
    (): ScientificAnalysisDetailModalState => ({
        scientificAnalysis: null
    })
